<template>
  <div :class="$style.timeTotals">
    <div :class="$style.totalItem">
      <span :class="$style.totalLabel">Total Elapsed:</span>
      <span :class="$style.totalTime">{{
        formatDuration(totalElapsedTime)
      }}</span>
    </div>
    <div :class="$style.totalItem">
      <span :class="$style.totalLabel">Total Estimated:</span>
      <span :class="$style.totalTime">{{
        formatDuration(totalEstimatedTime)
      }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Props {
  filteredTasks: any[];
}

const props = defineProps<Props>();

const totalElapsedTime = computed(() =>
  props.filteredTasks.reduce((sum, task) => sum + task.duration, 0)
);

const totalEstimatedTime = computed(() =>
  props.filteredTasks.reduce((sum, task) => sum + task.estimatedDuration, 0)
);

function formatDuration(ms: number): string {
  const hours = Math.floor(ms / (1000 * 60 * 60));
  const minutes = Math.floor((ms % (1000 * 60 * 60)) / (1000 * 60));
  return `${hours}h ${minutes}m`;
}
</script>

<style module>
.timeTotals {
  margin-top: 20px;
  padding: 15px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  display: flex;
  justify-content: flex-end;
  gap: 20px;
  flex-wrap: wrap;
}

.totalItem {
  display: flex;
  align-items: center;
  gap: 8px;
}

.totalLabel {
  font-size: 1.1em;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 500;
}

.totalTime {
  font-size: 1.1em;
  color: white;
  font-weight: 600;
}

/* Responsive adjustments for smaller screens */
@media (max-width: 768px) {
  .timeTotals {
    gap: 15px;
    padding: 12px;
  }
}

@media (max-width: 480px) {
  .timeTotals {
    gap: 10px;
    padding: 10px;
    justify-content: center;
  }
}
</style>
